import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _LightningFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M11.167 14.4H8.13c-1.409 0-2.113 0-2.408-.462-.295-.461.001-1.1.593-2.378l4.398-9.5c.374-.808.561-1.212.757-1.17.197.044.197.49.197 1.38V9.1c0 .236 0 .354.073.427s.191.073.427.073h3.037c1.408 0 2.112 0 2.407.462.295.461 0 1.1-.593 2.378l-4.398 9.5c-.374.808-.56 1.212-.757 1.17-.196-.044-.196-.49-.196-1.38V14.9c0-.236 0-.354-.074-.427-.073-.073-.19-.073-.426-.073" })));
}
const LightningFill = forwardRef(_LightningFill);
export { LightningFill };
